import { message } from 'antd';
import axios from 'helpers/axios';
import links from 'helpers/links';
import tokenRefresher from 'helpers/tokenRefresher';
import { clearToken, cookie, isDemo } from 'helpers/utility';
import translate from 'languageProvider/inline';
import Nprogress from 'nprogress';
import { replace } from 'redux-first-history';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import config from '../../config';
import actions from './actions';

function* loginRequestGenerator(action) {
  let hide;
  try {
    yield call(() => {
      Nprogress.start();
      hide = message.loading(translate('signin.wait'), 0);
    });
    yield put({
      type: actions.LOGIN_SUCCESS,
    });
    // yield put(push(`${config.baseUrl}/ats-prijave`));
  } catch (e) {
    message.error(translate('signin.error'));
    yield put({ type: actions.LOGIN_ERROR });
  } finally {
    yield call(() => {
      Nprogress.done();
      hide();
    });
  }
}

function* loginSuccessGenerator(payload) {
  if (!isDemo()) {
    const { expiresIn } = payload;
    // set schedule to refresh expiring tokens in miliseconds
    let refreshIn = 3_000_000; // 50 minutes
    try {
      if (expiresIn > 0) {
        /**
         * for some stupid reason cookie.set only accepts days for duration
         * so we calculate that from seconds we get in payload
         */
        yield cookie.set('loggedIn', true, expiresIn / 60 / 60 / 24);

        // remove one minute and schedule refresh in miliseconds
        yield (refreshIn = (expiresIn - 1) * 1000);
      }
    } catch (e) {
      log(e);
    }
    yield tokenRefresher.schedule(refreshIn);
  }
}

let loggingOut = false;

export function* logoutGenerator(action) {
  if (isDemo()) {
    // The demo has no account to sign out of: "log out" means leaving the demo.
    yield call([window.location, 'assign'], config.wwwHrlabUrl);
  } else {
    clearToken();
    cookie.erase('loggedIn');
    yield call(() => axios.get(`${config.apiUrl}/logout`));
    yield call(() => {
      if (action.payload.requestLogin) {
        if (!loggingOut) {
          loggingOut = true;
          window.location = links.oauth().requestLogin;
        }
      } else {
        window.location = links.oauth().logout;
      }
    });
  }
}

/**
 * Doesnt really check for anything. Its a QoA thing to skip
 * token request redirect. Assumes that the auth cookie is present
 * for the same duration as 'loggedIn' cookie. If cookies are out of sync
 * the app will continue exection until it hits 403 on any endpoint
 * and then start the login flow.
 */
export function* checkAuthorizationGenerator() {
  // The public demo has no session to check: the visitor is always signed in, so the
  // sign-in page (hrlab.rs links there) forwards straight to the dashboard.
  const loggedIn = isDemo() || cookie.get('loggedIn');
  if (loggedIn) {
    yield put({
      type: actions.LOGIN_SUCCESS,
    });
  }
}

function* validateGenerator(action) {
  try {
    const { origin, pathname } = window.location;
    const formData = new FormData();
    formData.append('code', action.payload);
    formData.append('redirect_uri', `${origin}${pathname}`);
    const response = yield call(
      (params) => axios.post(`${config.apiUrl}/login/authorization_code`, params),
      formData
    );
    const { expires_in } = response.data;
    yield put({
      type: actions.LOGIN_SUCCESS,
      expiresIn: expires_in,
    });
    const redirectTo = window.sessionStorage.getItem('redirectTo');
    yield put(replace(redirectTo || links.dashboard.url));
    window.sessionStorage.removeItem('redirectTo');
  } catch (e) {
    log(e);

    const Maintenance = (state) => state.Maintenance;
    const state = yield select(Maintenance);
    const maintenance = state.get('maintenance');
    if (!maintenance) {
      window.location = links.oauth().login;
    }
  }
}

export function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST', loginRequestGenerator);
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, loginSuccessGenerator);
}

// export function* loginError() {
//   yield takeEvery(actions.LOGIN_ERROR, function* () { });
// }

export function* logout() {
  yield takeEvery(actions.LOGOUT, logoutGenerator);
}

export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, checkAuthorizationGenerator);
}

export function* validate() {
  yield takeEvery(actions.VALIDATE, validateGenerator);
}

export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(loginRequest),
    fork(loginSuccess),
    // fork(loginError),
    fork(logout),
    fork(validate),
  ]);
}
